import { ClusterLayer, type ClusterProps } from './cluster-layer'

export function ClustersMedium(props: ClusterProps) {
	return <ClusterLayer {...props} size="medium" />
}
